import { useState } from 'react';
import './Name.scss';

function Name({ initial }) {
  const [name, setName] = useState('');

  return (
    <input
        type="text"
        className="calculator-name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={initial}
      />
  );
}

export default Name;
